import { combineReducers } from "redux"
import {
    UploaderReducer,
    UploaderState,
    UploaderAction
} from "./Interface/Uploader"
import {
    MessagesReducer,
    MessagesAction,
    MessagesState
} from "./MessagesReducer"
import { ModalReducer, ModalState, ModalAction } from "./ModalReducer"
import {
    BatchEditReducer,
    BatchEditState,
    BatchEditAction
} from "./Interface/BatchEditReducer"
import {
    EndpointsState,
    EndpointsAction,
    EndpointsReducer
} from "./EndpointsReducer"
import {
    InputRenderReducer,
    InputRenderState,
    InputRenderAction
} from "./InputRender/InputRenderReducer"
import { NetworkReducer, NetworkState, NetworkAction } from "./NetworkReducer"
import {
    DataFileExplorerAction,
    DataFileExplorerReducer,
    DataFileExplorerState
} from "./DataFileExplorer/DataFileExplorerReducer"
import {
    ColumnMapReducer,
    DataMapperState,
    DataMapperAction
} from "./DataFileExplorer/DataMapperReducer"
import { BrowserAction, BrowserState, BrowserReducer } from "./Browser"
import {
    RouteInfoAction,
    RouteInfoReducer,
    RouteInfoState
} from "./RouteInfoReducer"

export const ClientReducer = combineReducers({
    interface: combineReducers({
        batchEdit: BatchEditReducer,
        uploader: UploaderReducer
    }),
    inputRender: InputRenderReducer,
    messages: MessagesReducer,
    modal: ModalReducer,
    endpoints: EndpointsReducer,
    network: NetworkReducer,
    dataFileExplorer: combineReducers({
        explorer: DataFileExplorerReducer,
        columnMap: ColumnMapReducer
    }),
    browser: BrowserReducer,
    routeInfo: RouteInfoReducer
})

export interface ClientState {
    interface: {
        batchEdit: BatchEditState
        uploader: UploaderState
    }
    inputRender: InputRenderState
    modal: ModalState
    messages: MessagesState
    endpoints: EndpointsState
    network: NetworkState
    dataFileExplorer: {
        explorer: DataFileExplorerState
        columnMap: DataMapperState
    }
    browser: BrowserState
    routeInfo: RouteInfoState
}

export type ClientAction =
    | ModalAction
    | MessagesAction
    | BatchEditAction
    | EndpointsAction
    | InputRenderAction
    | UploaderAction
    | NetworkAction
    | DataFileExplorerAction
    | DataMapperAction
    | BrowserAction
    | RouteInfoAction
